// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg>path[data-v-52fdf92f]{transition:fill .2s ease}svg:hover>path[data-v-52fdf92f]{fill:var(--v-accentBlue-base)}", ""]);
// Exports
module.exports = exports;
